module.exports = __webpack_public_path__ + "img/icon23.7cd538df.png";